import React, {FC, useState, useEffect} from 'react'
import "../../assets/style/Button.css"
import { cn } from '../../utils'
import { FaCircleInfo } from 'react-icons/fa6'

type Props = {
  children?: string,
  onClick?:  (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  variant?: 'submit' | 'add' | 'delete' | 'undo' | 'save' | 'change' | 'download' | 'default',
  style?: any,
  _type?: "submit" | "button" | "reset" | undefined,
  disabled?: boolean,
  className?: string,
  onHover?: JSX.Element|JSX.Element[],
  title?: string,
  [key:string]: any
}

/**
 * 
 * @param _type determines the usual type in button. `submit`/`reset` will interact with current form.
 * @param variant determines the design of the button.
 * @param onHover is a JSX.Element that will be shown below the button on hover.
 * @returns 
 */
const Button: FC<Props> = ({children, onClick, variant, style, _type, disabled, className, onHover, title, ...props}) => {
  if (!variant) variant = "default"
  className = 'schipt-btn ' + (className ?? "")

  if (variant === "add" || variant === "submit") className += ' primary '
  else if (variant === "default") className += ' secondary '
  else if (variant === "delete") className += ' primary cancel '
  else if (variant === "undo") className += ' secondary cancel '

  const [loading, setLoading] = useState(false)
  
  return <div className='button-container'>
    <button className={cn(`btn`, className)} 
      disabled={disabled || loading}
      type={_type}
      title={title}
      onClick={async(e) => {
        setLoading(true);
        await onClick?.(e)
        setLoading(false);
      }}
      style={style} 
      {...props}
    >
      {children} 
      {title && !disabled ? <FaCircleInfo style={{marginLeft:"5px"}}/> : <></>}
    </button>
    { !onHover || disabled ?
      <></>
      :
      <div className='button-hover'>
        {onHover}
      </div>
    }
  </div>
}

export default Button